import { useTranslations } from '@npco/common-utils-translations'
import {
  Box,
  COLOR,
  Flex,
  NewBadge,
  Tutorial,
} from '@npco/zeller-design-system'

import { translationsShared } from 'translations'

import {
  ScrollableContent,
  Subtitle,
  Title,
} from '../../../SetupFlow/SetupFlowModal/SetupFlowModal.styled'

type MainContentProps = {
  bulletPoints: string[]
  ctaDescription?: string
  description: string
  testId?: string
  title: string
}

export const MainContent = ({
  bulletPoints,
  ctaDescription,
  description,
  testId,
  title,
}: MainContentProps) => {
  const tShared = useTranslations(translationsShared)

  return (
    <>
      <Box position="relative" display={{ _: 'block', LG: 'none' }}>
        <Box position="relative" top={{ _: '-38px', XS: '-42px' }}>
          <NewBadge text={tShared('new')} />
        </Box>
      </Box>
      <ScrollableContent data-testid={testId}>
        <Box display={{ _: 'none', LG: 'block' }}>
          <NewBadge text={tShared('new')} />
        </Box>
        <Title>{title}</Title>
        <Subtitle>{description}</Subtitle>
        <Flex flexDirection="column" gap="4px" lineHeight="24px">
          {bulletPoints.map((text) => (
            <Tutorial.BulletPoint
              key={text}
              iconColour={COLOR.GREEN_1000}
              text={text}
            />
          ))}
        </Flex>
        <Subtitle>{ctaDescription}</Subtitle>
      </ScrollableContent>
    </>
  )
}
